import React from "react";
import theme from "theme";
import { Theme, Link, Text, Box, Section, Image } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"index"} />
		<Helmet>
			<title>
				Jason C Mayes — systems and technology consultant
			</title>
			<meta name={"description"} content={"Web site created using quarkly.io"} />
			<meta property={"og:title"} content={"Jason C Mayes — systems and technology consultant"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/readme/cra/favicon-32x32.ico"} type={"image/x-icon"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Section padding="40px 0 40px 0" quarkly-title="Header">
			<Override
				slot="SectionContent"
				flex-direction="row"
				align-items="center"
				display="flex"
				justify-content="space-between"
			/>
			<Box
				empty-border-color="LightGray"
				width="30%"
				align-items="center"
				lg-width="50%"
				empty-min-height="64px"
				empty-border-style="solid"
				display="flex"
				sm-width="70%"
				empty-min-width="64px"
				empty-border-width="1px"
			>
				<Text color="--light" margin="0px 0px 0px 0px" font="--headline3">
					Jason C Mayes
				</Text>
			</Box>
			<Box
				sm-width="30%"
				empty-min-width="64px"
				empty-min-height="64px"
				empty-border-style="solid"
				display="flex"
				align-items="center"
				empty-border-width="1px"
				empty-border-color="LightGray"
				width="70%"
				lg-width="50%"
			>
				<Components.QuarklycommunityKitMobileSidePanel>
					<Override slot="Content" justify-content="flex-end" background="--color-dark" padding="0px 0px 0px 0px" />
					<Override slot="Button Text" md-color="--light" md-font="--base" md-text-transform="uppercase" />
					<Override slot="Button Icon" md-color="--light" />
					<Box
						md-padding="20px 0px 20px 0px"
						display="flex"
						justify-content="flex-end"
						align-items="center"
						md-flex-direction="column"
					>
						<Link
							md-margin="20px 0px 0px 0px"
							href="https://www.linkedin.com/in/jasoncmayes/"
							text-decoration-line="initial"
							color="--lightD1"
							font="--base"
							margin="0px 0px 0px 20px"
							target="_blank"
						>
							LinkedIn
						</Link>
					</Box>
				</Components.QuarklycommunityKitMobileSidePanel>
			</Box>
		</Section>
		<Section padding="50px 0 50px 0" quarkly-title="HeroBlock">
			<Image
				width="100%"
				src="https://uploads.quarkly.io/69aa968ad788530023e4aaba/images/headeralpha.jpg?v=2026-03-07T10:42:33.854Z"
				align-self="auto"
				order="0"
				display="block"
				flex="0 1 auto"
				object-fit="cover"
				height="500px"
				margin="0px 0px 80px 0px"
				overflow="visible"
				srcSet="https://smartuploads.quarkly.io/69aa968ad788530023e4aaba/images/headeralpha.jpg?v=2026-03-07T10%3A42%3A33.854Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/69aa968ad788530023e4aaba/images/headeralpha.jpg?v=2026-03-07T10%3A42%3A33.854Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/69aa968ad788530023e4aaba/images/headeralpha.jpg?v=2026-03-07T10%3A42%3A33.854Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/69aa968ad788530023e4aaba/images/headeralpha.jpg?v=2026-03-07T10%3A42%3A33.854Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/69aa968ad788530023e4aaba/images/headeralpha.jpg?v=2026-03-07T10%3A42%3A33.854Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/69aa968ad788530023e4aaba/images/headeralpha.jpg?v=2026-03-07T10%3A42%3A33.854Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/69aa968ad788530023e4aaba/images/headeralpha.jpg?v=2026-03-07T10%3A42%3A33.854Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
			/>
			<Text
				sm-margin="0px 0px 0px 0px"
				md-margin="0px 0px 0px 0px"
				margin="0px 0px 0px 0"
				color="--lightD1"
				md-font="normal 700 52px/1.1 &quot;Inter&quot;, sans-serif"
				sm-font="normal 700 32px/1.3 &quot;Inter&quot;, sans-serif"
				sm-text-align="center"
				font="--headline4"
				md-text-align="center"
			>
				Results-driven Operations and Systems Leader with over 20 years of hands-on expertise, currently at Artisan Design Group, specializing in multi-site process optimization, lean manufacturing, and ERP transformations (including SAP). Proven ability to drive cost reductions, enhance production efficiency, and standardize operations across 30+ branches, delivering measurable improvements in quality, safety, and scalability. Skilled in business/technology consulting for project management, tech implementations, and security.
			</Text>
		</Section>
		<Section padding="50px 0 100px 0">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				justify-content="center"
				flex-direction="column"
				flex-wrap="no-wrap"
			/>
			<Box
				display="flex"
				margin="0px 0px 0px 0px"
				sm-flex-direction="column"
				empty-min-width="64px"
				empty-min-height="64px"
				empty-border-color="LightGray"
				sm-margin="32px 0px 0px 0px"
				empty-border-width="1px"
				empty-border-style="solid"
				flex-wrap="wrap"
				min-width="100%"
			>
				<Box
					empty-border-width="1px"
					empty-border-color="LightGray"
					sm-width="100%"
					sm-justify-content="flex-start"
					sm-padding="0px 0px 16px 0px"
					empty-min-width="64px"
					empty-min-height="64px"
					empty-border-style="solid"
					display="flex"
					width="20%"
				>
					<Text margin="0px 0px 0px 0px" font="normal 300 18px/1.5 --fontFamily-googleInter" color="--light">
						Artisan Design Group
						<br />
						<br />
						Lead Systems Integration Consultant
					</Text>
				</Box>
				<Box
					empty-border-color="LightGray"
					display="flex"
					width="20%"
					sm-padding="0px 0px 16px 0px"
					empty-min-width="64px"
					empty-border-width="1px"
					empty-border-style="solid"
					justify-content="center"
					sm-width="100%"
					sm-justify-content="flex-start"
					empty-min-height="64px"
				>
					<Text font="normal 600 18px/1.5 --fontFamily-googleInter" color="--light" margin="0px 0px 0px 0px">
						2025 - Current
					</Text>
				</Box>
				<Box
					empty-border-color="LightGray"
					display="flex"
					sm-width="100%"
					sm-justify-content="flex-start"
					empty-min-height="64px"
					empty-border-width="1px"
					width="60%"
					sm-padding="0px 0px 16px 0px"
					empty-min-width="64px"
					empty-border-style="solid"
					font="14px sans-serif"
				>
					<Text font="--lead" color="--lightD1" margin="0px 0px 0px 0px" md-font="500 20px/1.3 --fontFamily-googleInter">
						- Support countertop manufacturing operations from a technology perspective.
						<br />
						- Drive integration between ERP systems (e.g., Infor M3) and fabrication software for efficiency.
						<br />
						- Manage and optimize tech platforms, including license administration and software transitions.{"\n\n\n"}
					</Text>
				</Box>
			</Box>
			<Box
				display="flex"
				margin="86px 0px 0px 0px"
				sm-flex-direction="column"
				empty-min-width="64px"
				empty-min-height="64px"
				empty-border-color="LightGray"
				sm-margin="32px 0px 0px 0px"
				empty-border-width="1px"
				empty-border-style="solid"
				flex-wrap="wrap"
				min-width="100%"
			>
				<Box
					empty-border-width="1px"
					empty-border-color="LightGray"
					sm-width="100%"
					sm-justify-content="flex-start"
					sm-padding="0px 0px 16px 0px"
					empty-min-width="64px"
					empty-min-height="64px"
					empty-border-style="solid"
					display="flex"
					width="20%"
				>
					<Text margin="0px 0px 0px 0px" font="normal 300 18px/1.5 --fontFamily-googleInter" color="--light">
						Haulink
						<br />
						<br />
						Technology Consultant
					</Text>
				</Box>
				<Box
					empty-border-color="LightGray"
					display="flex"
					width="20%"
					sm-padding="0px 0px 16px 0px"
					empty-min-width="64px"
					empty-border-width="1px"
					empty-border-style="solid"
					justify-content="center"
					sm-width="100%"
					sm-justify-content="flex-start"
					empty-min-height="64px"
				>
					<Text font="normal 600 18px/1.5 --fontFamily-googleInter" color="--light" margin="0px 0px 0px 0px">
						2025 - Current
					</Text>
				</Box>
				<Box
					empty-border-color="LightGray"
					display="flex"
					sm-width="100%"
					sm-justify-content="flex-start"
					empty-min-height="64px"
					empty-border-width="1px"
					width="60%"
					sm-padding="0px 0px 16px 0px"
					empty-min-width="64px"
					empty-border-style="solid"
				>
					<Text font="--lead" color="--lightD1" margin="0px 0px 0px 0px" md-font="500 20px/1.3 --fontFamily-googleInter">
						- Lead security initiatives for a 25-employee trucking startup, including MFA, hardware inventory, secure wiping, and management software rollout.{" \n\t"}
						<br />
						- Lead UAT for deployments.{"\n\t"}
						<br />
						- Bridge operations and IT for platform adoptions like Dialpad to Clerkchat, and tools like Jira/Notion.{" \n\t"}
						<br />
						- Provide project management support to CEO on tech initiatives.{"\n\n\n"}
					</Text>
				</Box>
			</Box>
			<Box
				display="flex"
				margin="86px 0px 0px 0px"
				sm-flex-direction="column"
				empty-min-width="64px"
				empty-min-height="64px"
				empty-border-color="LightGray"
				sm-margin="32px 0px 0px 0px"
				empty-border-width="1px"
				empty-border-style="solid"
				flex-wrap="wrap"
				min-width="100%"
			>
				<Box
					empty-border-width="1px"
					empty-border-color="LightGray"
					sm-width="100%"
					sm-justify-content="flex-start"
					sm-padding="0px 0px 16px 0px"
					empty-min-width="64px"
					empty-min-height="64px"
					empty-border-style="solid"
					display="flex"
					width="20%"
				>
					<Text margin="0px 0px 0px 0px" font="normal 300 18px/1.5 --fontFamily-googleInter" color="--light">
						Interior Logic Group
						<br />
						<br />
						Senior Manager, Operations
					</Text>
				</Box>
				<Box
					empty-border-color="LightGray"
					display="flex"
					width="20%"
					sm-padding="0px 0px 16px 0px"
					empty-min-width="64px"
					empty-border-width="1px"
					empty-border-style="solid"
					justify-content="center"
					sm-width="100%"
					sm-justify-content="flex-start"
					empty-min-height="64px"
				>
					<Text font="normal 600 18px/1.5 --fontFamily-googleInter" color="--light" margin="0px 0px 0px 0px">
						2003 - 2025
					</Text>
				</Box>
				<Box
					empty-border-color="LightGray"
					display="flex"
					sm-width="100%"
					sm-justify-content="flex-start"
					empty-min-height="64px"
					empty-border-width="1px"
					width="60%"
					sm-padding="0px 0px 16px 0px"
					empty-min-width="64px"
					empty-border-style="solid"
				>
					<Text font="--lead" color="--lightD1" margin="0px 0px 0px 0px" md-font="500 20px/1.3 --fontFamily-googleInter">
						- Led countertop fabrication optimization, implementing digital templating, CAD, scheduling, and procurement; scaled division and deployed best practices nationwide.{" \n\t"}
						<br />
						- Directed SAP ERP conversion across 30+ branches ($250M revenue), designing dashboards that reduced labor by 90%.{" \n\t"}
						<br />
						- Deployed Power BI for real-time reporting, training 200+ employees to bridge IT and operations.{" \n\t"}
						<br />
						- Reduced aged inventory by 33% and write-offs by 50% via lean practices, procurement, and JIT principles.{" \n\n\n"}
					</Text>
				</Box>
			</Box>
		</Section>
		<Section padding="90px 0 90px 0" sm-padding="74px 0 74px 0" quarkly-title="Footer">
			<Override slot="SectionContent" md-align-items="center" flex-direction="row" md-flex-direction="column" />
			<Box
				empty-min-width="64px"
				empty-min-height="64px"
				md-justify-content="center"
				md-align-items="center"
				md-padding="16px 16px 16px 16px"
				md-width="100%"
				empty-border-width="1px"
				empty-border-style="solid"
				empty-border-color="LightGray"
				width="33.333%"
				display="flex"
			>
				<Text margin="0px 0px 0px 0px" font="--base" color="--light" sm-text-align="center">
					Jason C Mayes
				</Text>
			</Box>
			<Box
				md-padding="16px 16px 16px 16px"
				empty-min-width="64px"
				empty-border-width="1px"
				empty-border-style="solid"
				width="33.333%"
				display="flex"
				md-align-items="center"
				md-justify-content="center"
				empty-min-height="64px"
				empty-border-color="LightGray"
				md-width="100%"
				align-items="center"
				flex-direction="row"
				justify-content="center"
			>
				<Text
					margin="0px 0px 0px 0px"
					font="--base"
					color="--light"
					sm-text-align="center"
					md-text-align="center"
				>
					JCM.biz@pm.me
				</Text>
			</Box>
			<Box
				md-width="100%"
				empty-min-width="64px"
				empty-border-style="solid"
				width="33.333%"
				md-justify-content="center"
				md-padding="16px 16px 16px 16px"
				empty-min-height="64px"
				empty-border-width="1px"
				empty-border-color="LightGray"
				display="flex"
				md-align-items="center"
				align-items="center"
				flex-direction="row"
				justify-content="flex-end"
			>
				<Text
					margin="0px 0px 0px 0px"
					font="--base"
					color="--light"
					sm-text-align="center"
					md-text-align="center"
				>
					Kansas City, KS
				</Text>
			</Box>
		</Section>
		<Link
			font={"--capture"}
			font-size={"10px"}
			position={"fixed"}
			bottom={"12px"}
			right={"12px"}
			z-index={"4"}
			border-radius={"4px"}
			padding={"5px 12px 4px"}
			background-color={"--dark"}
			opacity={"0.6"}
			hover-opacity={"1"}
			color={"--light"}
			cursor={"pointer"}
			transition={"--opacityOut"}
			quarkly-title={"Badge"}
			text-decoration-line={"initial"}
			href={"https://quarkly.io/"}
			target={"_blank"}
		>
			Made on Quarkly
		</Link>
		<RawHtml>
			<style place={"endOfHead"} rawKey={"60da14fa3f4eb1001ea27687"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});